import React from "react";
import "./pagination.scss";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  const handlePageChange = (page) => {
    if (page >= 0 && page < totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    return (
      <ul
        className="pagination"
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          textAlign: "center",
          color: "#286a94",
          gap: "6px",
        }}
      >
        <li className={`${currentPage === 0 ? "disabled" : ""}`}>
          <span
            className="page-link"
            style={{
              backgroundColor: currentPage === 0 ? "#e0e0e0" : "transparent",
              cursor: currentPage === 0 ? "not-allowed" : "pointer",
              color: "#286a94",
              minWidth: "45px",
              padding: "6px 10px",
              borderRadius: "5px",
              textAlign: "center",
              display: "inline-block",
              pointerEvents: currentPage === 0 ? "none" : "auto",
            }}
            onClick={(e) => {
              e.preventDefault();
              if (currentPage > 0) handlePageChange(currentPage - 1);
            }}
          >
            Previous
          </span>
        </li>

        {Array.from({ length: totalPages }, (_, index) => {
          if (
            index < 3 ||
            index >= totalPages - 2 ||
            (currentPage >= 3 &&
              currentPage <= totalPages - 4 &&
              index === currentPage - 1) ||
            index === currentPage ||
            index === currentPage + 1
          ) {
            return (
              <li
                key={index}
                className={`page-item ${currentPage === index ? "active" : ""}`}
              >
                <span
                  className="page-link"
                  onClick={() => handlePageChange(index)}
                  style={{
                    cursor: currentPage === index ? "default" : "pointer",
                    backgroundColor:
                      currentPage === index ? "#007bff" : "transparent",
                    color: currentPage === index ? "#fff" : "#286a94",
                    minWidth: "45px",
                    padding: "6px 10px",
                    display: "inline-block",
                    textAlign: "center",
                    border:
                      currentPage === index
                        ? "2px solid #0056b3"
                        : "1px solid #286a94",
                    borderRadius: "50%",
                    fontWeight: currentPage === index ? "bold" : "normal",
                    boxShadow:
                      currentPage === index
                        ? "0 0 5px rgba(0,0,0,0.3)"
                        : "none",
                  }}
                >
                  {index + 1}
                </span>
              </li>
            );
          } else if (index === 3 && currentPage > 3) {
            return (
              <li key={index} className="page-item">
                <span
                  className="page-link"
                  style={{
                    minWidth: "45px",
                    display: "inline-block",
                    textAlign: "center",
                  }}
                >
                  ...
                </span>
              </li>
            );
          } else if (index === totalPages - 4 && currentPage < totalPages - 4) {
            return (
              <li key={index} className="page-item">
                <span
                  className="page-link"
                  style={{
                    minWidth: "45px",
                    display: "inline-block",
                    textAlign: "center",
                  }}
                >
                  ...
                </span>
              </li>
            );
          }
          return null;
        })}

        <li className={`${currentPage === totalPages - 1 ? "disabled" : ""}`}>
          <span
            className="page-link"
            style={{
              backgroundColor:
                currentPage === totalPages - 1 ? "#e0e0e0" : "transparent",
              cursor:
                currentPage === totalPages - 1 ? "not-allowed" : "pointer",
              color: "#286a94",
              minWidth: "45px",
              padding: "6px 10px",
              borderRadius: "5px",
              textAlign: "center",
              display: "inline-block",
              pointerEvents: currentPage === totalPages - 1 ? "none" : "auto",
            }}
            onClick={(e) => {
              e.preventDefault();
              if (currentPage < totalPages - 1)
                handlePageChange(currentPage + 1);
            }}
          >
            Next
          </span>
        </li>
      </ul>
    );
  };

  return (
    <div className="paginate_container">
      <nav aria-label="Page navigation example" style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 auto",
            width: "100%",
          }}
          className="pagination justify-content-center"
        >
          {renderPageNumbers()}
        </div>
      </nav>
    </div>
  );
};

export default Pagination;
